/**
 * ⚠️ HARDCODED / TEMPORARY — ported verbatim from dane's etf_website
 * (`frontend/app/etf-website/data/constituent-sectors.ts`) on 2026-06-24.
 * De-hardcode later: this ticker→sector map should eventually be sourced
 * from the holdings ingestion feed / admin DB rather than baked in here.
 * Until then it is REQUIRED for the thematic/equity Sector Breakdown to
 * render real sectors — without it `computeSectorsFromHoldings` maps every
 * live holding to "Other" and the chart collapses to a single grey wedge.
 *
 * Canonical ticker → sector mapping.
 *
 * This is the single source of truth that every page pulls from.
 * When a constituent changes sector classification, update it here
 * and every fund’s sector breakdown recomputes automatically.
 *
 * Key rules:
 *  - Tickers are uppercase ("AAPL", not "aapl")
 *  - Sector names use GICS / NAICS standard labels
 *  - Special entries: TBILL = "Fixed Income", CASH = "Cash & Equivalents",
 *    FLEX = "Options", IAU/SIVR/PALL/PLTM = "Precious Metals"
 *  - When you add a new holding to any fund, add its ticker here too
 */
export const CONSTITUENT_SECTORS: Record<string, string> = {
  AAL: "Industrials",
  AAON: "Industrials",
  AAPL: "Technology",
  ABB: "Industrials",
  ABBV: "Healthcare",
  ABEV: "Consumer Staples",
  ABM: "Industrials",
  ABNB: "Consumer Discretionary",
  ABT: "Healthcare",
  ACEL: "Consumer Discretionary",
  ACHR: "Industrials",
  ACLS: "Technology",
  ACN: "Technology",
  ACTG: "Technology",
  ADBE: "Technology",
  ADI: "Technology",
  ADP: "Industrials",
  AEHR: "Technology",
  AEO: "Consumer Discretionary",
  AEP: "Utilities",
  AES: "Utilities",
  AEVA: "Technology",
  AFRM: "Financials",
  AGS: "Consumer Discretionary",
  AGX: "Industrials",
  AGYS: "Technology",
  AI: "Technology",
  AIG: "Financials",
  AIR: "Industrials",
  AJRD: "Industrials",
  ALB: "Materials",
  ALK: "Industrials",
  ALNY: "Healthcare",
  ALOT: "Technology",
  ALPP: "Industrials",
  ALRM: "Technology",
  AM: "Energy",
  AMAT: "Technology",
  AMBA: "Technology",
  AMD: "Information Technology",
  AMGN: "Healthcare",
  AMKR: "Technology",
  AMPX: "Technology",
  AMSC: "Industrials",
  AMT: "Real Estate",
  AMWL: "Healthcare",
  AMZN: "Information Technology",
  ANET: "Technology",
  ANF: "Consumer Discretionary",
  ANSS: "Technology",
  AOS: "Industrials",
  APD: "Materials",
  APH: "Industrials",
  APLS: "Healthcare",
  AR: "Energy",
  ARBK: "Technology",
  ARCB: "Industrials",
  ARCO: "Consumer Discretionary",
  ARE: "Real Estate",
  ARGX: "Healthcare",
  ARM: "Technology",
  ARQQ: "Technology",
  ARRY: "Industrials",
  ARWR: "Healthcare",
  ASC: "Industrials",
  ASML: "Information Technology",
  ASTR: "Industrials",
  ASTS: "Communication Services",
  ASX: "Technology",
  ATEX: "Communication Services",
  ATI: "Materials",
  ATKR: "Materials",
  ATRO: "Industrials",
  AVAV: "Industrials",
  AVB: "Real Estate",
  AVGO: "Information Technology",
  AVNW: "Technology",
  AVTR: "Healthcare",
  AWK: "Utilities",
  AXISBANK: "Financials",
  AXON: "Technology",
  AXP: "Financials",
  AYI: "Industrials",
  AZN: "Healthcare",
  AZTA: "Healthcare",
  B3SA3: "Financials",
  BA: "Industrials",
  BABA: "Consumer Disc.",
  BAC: "Financials",
  BACHY: "Financials",
  BAH: "Industrials",
  BAJFINANCE: "Financials",
  BALY: "Consumer Discretionary",
  BBD: "Financials",
  BE: "Energy",
  BEAM: "Healthcare",
  BEKE: "Real Estate",
  BETZ: "Consumer Discretionary",
  BGS: "Consumer Discretionary",
  BHARTIARTL: "Comm. Services",
  BHF: "Financials",
  BIDU: "Comm. Services",
  BILI: "Comm. Services",
  BILL: "Technology",
  BIO: "Healthcare",
  BIRD: "Consumer Discretionary",
  BITF: "Technology",
  BK: "Financials",
  BKNG: "Consumer Discretionary",
  BKR: "Energy",
  BKSY: "Technology",
  BLDE: "Industrials",
  BLDP: "Industrials",
  BLDR: "Industrials",
  BLK: "Financials",
  BMY: "Healthcare",
  BNGO: "Healthcare",
  BP: "Energy",
  BPMC: "Healthcare",
  BRFS: "Consumer Discretionary",
  "BRK.B": "Financials",
  BRKS: "Technology",
  BROS: "Consumer Discretionary",
  BRPHF: "Technology",
  BSY: "Technology",
  BTBT: "Technology",
  BTCS: "Technology",
  BTDR: "Technology",
  BWXT: "Industrials",
  BYD: "Consumer Discretionary",
  BYDDF: "Consumer Disc.",
  BZ: "Comm. Services",
  C: "Financials",
  CACI: "Technology",
  CAMT: "Technology",
  CAN: "Technology",
  CARR: "Manufacturing",
  CASH: "Cash",
  CAT: "Industrials",
  CATHF: "Financials",
  CB: "Financials",
  CBOE: "Financials",
  CCI: "Real Estate",
  CCJ: "Energy",
  CCL: "Consumer Discretionary",
  CDNA: "Healthcare",
  CDNS: "Technology",
  CE: "Materials",
  CEG: "Utilities",
  CELGF: "Healthcare",
  CELH: "Consumer Discretionary",
  CENTA: "Consumer Discretionary",
  CEO: "Energy",
  CEVA: "Technology",
  CFG: "Financials",
  CFR: "Financials",
  CGNX: "Technology",
  CHD: "Consumer Discretionary",
  CHDN: "Consumer Discretionary",
  CHEF: "Consumer Discretionary",
  CHH: "Consumer Discretionary",
  CHKP: "Technology",
  CHPT: "Industrials",
  CHRW: "Industrials",
  CHT: "Comm. Services",
  CICHY: "Financials",
  CIEN: "Technology",
  CIFR: "Technology",
  CIHKY: "Financials",
  CL: "Consumer Discretionary",
  CLNE: "Energy",
  CLSK: "Technology",
  CMA: "Financials",
  CMG: "Consumer Disc.",
  CMRE: "Industrials",
  CMTL: "Technology",
  CNTY: "Consumer Discretionary",
  CNXN: "Technology",
  COHR: "Technology",
  COIN: "Financials",
  COKE: "Consumer Discretionary",
  COLB: "Financials",
  COLM: "Consumer Discretionary",
  CONE: "Real Estate",
  COP: "Energy",
  COR: "Real Estate",
  CORT: "Healthcare",
  CORZ: "Technology",
  COST: "Consumer Staples",
  COTY: "Consumer Discretionary",
  CPER: "Commodities",
  CPL: "Utilities",
  CPLP: "Industrials",
  CPRI: "Consumer Discretionary",
  CQP: "Energy",
  CRM: "Technology",
  CROX: "Consumer Discretionary",
  CRSP: "Healthcare",
  CRWD: "Technology",
  CSCO: "Technology",
  CSX: "Industrials",
  CTBCF: "Financials",
  CTO: "Real Estate",
  CTRA: "Energy",
  CTRM: "Industrials",
  CURO: "Financials",
  CURV: "Consumer Discretionary",
  CUTR: "Healthcare",
  CVX: "Energy",
  CW: "Industrials",
  CWAN: "Technology",
  CYBR: "Technology",
  CZR: "Consumer Discretionary",
  D: "Utilities",
  DAC: "Industrials",
  DAL: "Industrials",
  DASH: "Consumer Discretionary",
  DD: "Materials",
  DDD: "Technology",
  DDOG: "Technology",
  DE: "Industrials",
  DECK: "Consumer Discretionary",
  DGII: "Technology",
  DHR: "Healthcare",
  DIGI: "Technology",
  DIN: "Consumer Discretionary",
  DIOD: "Technology",
  DIS: "Communication Services",
  DJP: "Commodities",
  DKNG: "Consumer Discretionary",
  DLB: "Technology",
  DLO: "Technology",
  DLR: "Real Estate",
  DLTAF: "Technology",
  DNA: "Healthcare",
  DNN: "Energy",
  DNUT: "Consumer Discretionary",
  DOCN: "Technology",
  DOCS: "Healthcare",
  DOW: "Materials",
  DRS: "Industrials",
  DSX: "Industrials",
  DTC: "Consumer Discretionary",
  DTM: "Energy",
  DUK: "Utilities",
  DUOL: "Technology",
  DVN: "Energy",
  DXCM: "Healthcare",
  EAT: "Consumer Discretionary",
  EATON: "Manufacturing",
  ECL: "Materials",
  ED: "Utilities",
  EDIT: "Healthcare",
  EDRY: "Industrials",
  EGLE: "Industrials",
  EH: "Industrials",
  EIX: "Utilities",
  EL: "Consumer Discretionary",
  ELF: "Consumer Discretionary",
  ELV: "Healthcare",
  ELYS: "Technology",
  EME: "Industrials",
  EMR: "Industrials",
  ENB: "Energy",
  ENPH: "Technology",
  ENR: "Consumer Discretionary",
  ENS: "Industrials",
  ENSG: "Healthcare",
  ENTG: "Technology",
  EOG: "Energy",
  EOSE: "Industrials",
  EPD: "Energy",
  EQH: "Financials",
  EQIX: "Real Estate",
  EQR: "Real Estate",
  EQT: "Energy",
  ERJ: "Industrials",
  ES: "Utilities",
  ESEA: "Industrials",
  ESFHF: "Financials",
  ESLT: "Technology",
  ET: "Energy",
  ETN: "Industrials",
  EU: "Energy",
  EVRI: "Consumer Discretionary",
  EVTC: "Technology",
  EVTL: "Industrials",
  EWBC: "Financials",
  EXAS: "Healthcare",
  EXC: "Utilities",
  EXPD: "Industrials",
  EXPE: "Consumer Discretionary",
  F: "Consumer Disc.",
  FANG: "Energy",
  FARM: "Consumer Discretionary",
  FARO: "Technology",
  FAST: "Industrials",
  FATE: "Healthcare",
  FCUUF: "Energy",
  FCX: "Materials",
  FDX: "Industrials",
  FELE: "Industrials",
  FFIV: "Technology",
  FHN: "Financials",
  FI: "Financials",
  FIGS: "Consumer Discretionary",
  FIX: "Industrials",
  FIZZ: "Consumer Discretionary",
  FLEX: "Options",
  FLIR: "Technology",
  FLL: "Consumer Discretionary",
  FLNC: "Industrials",
  FLNG: "Energy",
  FLUT: "Consumer Discretionary",
  FLYW: "Technology",
  FN: "Technology",
  FNV: "Materials",
  FORM: "Technology",
  FOUR: "Financials",
  FOX: "Communication Services",
  FPMUF: "Materials",
  FREYR: "Industrials",
  FRO: "Industrials",
  FTNT: "Technology",
  FUBNF: "Financials",
  FUN: "Consumer Discretionary",
  GAN: "Technology",
  GBCI: "Financials",
  GBX: "Industrials",
  GD: "Industrials",
  GDDY: "Technology",
  GDOT: "Financials",
  GDRX: "Healthcare",
  GE: "Industrials",
  GENI: "Technology",
  GEV: "Industrials",
  GH: "Healthcare",
  GIII: "Consumer Discretionary",
  GIL: "Consumer Discretionary",
  GILD: "Healthcare",
  GILT: "Technology",
  GIS: "Consumer Staples",
  GLATF: "Energy",
  GLNG: "Energy",
  GLPI: "Real Estate",
  GLXY: "Financials",
  GM: "Consumer Disc.",
  GMBL: "Consumer Discretionary",
  GNK: "Industrials",
  GNOG: "Consumer Discretionary",
  GNRC: "Industrials",
  GOGL: "Industrials",
  GOOG: "Communication Services",
  GOOGL: "Information Technology",
  GOOS: "Consumer Discretionary",
  GPN: "Financials",
  GPOR: "Energy",
  GPS: "Consumer Discretionary",
  GRC: "Industrials",
  GREE: "Technology",
  GRMN: "Technology",
  GS: "Financials",
  GSAT: "Communication Services",
  GTE: "Industrials",
  GTLB: "Technology",
  H: "Consumer Discretionary",
  HA: "Industrials",
  HAIN: "Consumer Discretionary",
  HAL: "Energy",
  HALO: "Healthcare",
  HAYW: "Materials",
  HBAN: "Financials",
  HBI: "Consumer Discretionary",
  HCAT: "Healthcare",
  HCLTECH: "Technology",
  HD: "Consumer Disc.",
  HDB: "Financials",
  HEI: "Industrials",
  HELE: "Consumer Discretionary",
  HES: "Energy",
  HII: "Industrials",
  HIMS: "Healthcare",
  HIVE: "Technology",
  HLIT: "Technology",
  HLT: "Consumer Discretionary",
  HNHPF: "Technology",
  HON: "Industrials",
  HOOD: "Financials",
  HSBC: "Financials",
  HSY: "Consumer Staples",
  HTHT: "Consumer Discretionary",
  HTLD: "Industrials",
  HUBB: "Industrials",
  HUBG: "Industrials",
  HUT: "Technology",
  HWM: "Industrials",
  HXL: "Materials",
  HXSCF: "Technology",
  HYLN: "Industrials",
  HYMOF: "Consumer Disc.",
  HYMTF: "Consumer Disc.",
  IART: "Healthcare",
  IAU: "Precious Metals",
  IBM: "Technology",
  IBN: "Financials",
  IBP: "Industrials",
  ICE: "Financials",
  IDCBY: "Financials",
  IDCC: "Technology",
  IEX: "Industrials",
  IFF: "Materials",
  IGT: "Consumer Discretionary",
  ILMN: "Healthcare",
  ILUKA: "Manufacturing",
  IMMR: "Technology",
  INFY: "Technology",
  INMD: "Healthcare",
  INSG: "Technology",
  INSP: "Healthcare",
  INSW: "Industrials",
  INTC: "Technology",
  INTU: "Technology",
  IONQ: "Technology",
  IONS: "Healthcare",
  IPAR: "Consumer Discretionary",
  IPG: "Communication Services",
  IPGP: "Technology",
  IQ: "Comm. Services",
  IRBT: "Consumer Discretionary",
  IRDM: "Communication Services",
  IREN: "Technology",
  IRM: "Real Estate",
  IRTC: "Healthcare",
  ISDR: "Technology",
  ISRG: "Healthcare",
  ITC: "Consumer Staples",
  ITCI: "Healthcare",
  ITUB: "Financials",
  ITW: "Industrials",
  JACK: "Consumer Discretionary",
  JBHT: "Industrials",
  JBLU: "Industrials",
  JBSS3: "Consumer Staples",
  JD: "Consumer Disc.",
  JJSF: "Consumer Discretionary",
  JNJ: "Healthcare",
  JOBY: "Industrials",
  JPM: "Financials",
  KAMN: "Industrials",
  KB: "Financials",
  KDP: "Consumer Discretionary",
  KEX: "Industrials",
  KEY: "Financials",
  KFRC: "Industrials",
  KHC: "Consumer Staples",
  KKOCF: "Comm. Services",
  KLAC: "Technology",
  KMB: "Consumer Staples",
  KMI: "Energy",
  KNX: "Industrials",
  KO: "Consumer Discretionary",
  KOTAKBANK: "Financials",
  KTOS: "Technology",
  KUASF: "Comm. Services",
  L: "Financials",
  LAC: "Materials",
  LASR: "Technology",
  LAZR: "Technology",
  LC: "Financials",
  LDOS: "Industrials",
  LEU: "Energy",
  LFMD: "Healthcare",
  LGCLF: "Materials",
  LGEAF: "Consumer Disc.",
  LGND: "Healthcare",
  LHX: "Industrials",
  LIDR: "Technology",
  LII: "Industrials",
  LILM: "Industrials",
  LIN: "Materials",
  LIND: "Consumer Discretionary",
  LITE: "Technology",
  LLY: "Healthcare",
  LMND: "Financials",
  LMT: "Industrials",
  LNDC: "Consumer Discretionary",
  LNG: "Energy",
  LOCO: "Consumer Discretionary",
  LOW: "Consumer Disc.",
  LRCX: "Technology",
  LSCC: "Technology",
  LT: "Industrials",
  LTBR: "Energy",
  LTHM: "Materials",
  LTRSF: "Energy",
  LULU: "Consumer Discretionary",
  LUNR: "Industrials",
  LUV: "Industrials",
  LVMUY: "Consumer Disc.",
  LVS: "Consumer Discretionary",
  LX: "Financials",
  LYFT: "Technology",
  MA: "Financials",
  MANH: "Technology",
  MANT: "Technology",
  MAR: "Consumer Discretionary",
  MARA: "Technology",
  MARUTI: "Consumer Disc.",
  MASI: "Healthcare",
  MATX: "Industrials",
  MAXN: "Technology",
  MCD: "Consumer Disc.",
  MCHP: "Technology",
  MCRI: "Consumer Discretionary",
  MDLZ: "Consumer Staples",
  MDTKF: "Technology",
  MDXG: "Healthcare",
  ME: "Healthcare",
  MEG: "Industrials",
  MEGAF: "Financials",
  MET: "Financials",
  META: "Information Technology",
  MFIN: "Financials",
  MGM: "Consumer Discretionary",
  MGPI: "Consumer Discretionary",
  MKSI: "Technology",
  MLCO: "Consumer Discretionary",
  MLM: "Materials",
  MNDT: "Technology",
  MNSO: "Consumer Disc.",
  MNST: "Consumer Discretionary",
  MO: "Consumer Staples",
  "MOG.A": "Industrials",
  MOGO: "Technology",
  MP: "Materials",
  MPC: "Energy",
  MPLX: "Energy",
  MPNGY: "Industrials",
  MQ: "Technology",
  MRCY: "Technology",
  MRK: "Healthcare",
  MRTN: "Industrials",
  MRVL: "Technology",
  MS: "Financials",
  MSCI: "Financials",
  MSFT: "Information Technology",
  MSI: "Technology",
  MSTR: "Technology",
  MTN: "Consumer Discretionary",
  MTZ: "Industrials",
  MU: "Technology",
  MVIS: "Technology",
  MVST: "Technology",
  MWA: "Industrials",
  MYGN: "Healthcare",
  MYRG: "Industrials",
  NCLH: "Consumer Discretionary",
  NCTY: "Technology",
  NDAQ: "Financials",
  NDSN: "Industrials",
  NEE: "Utilities",
  NEM: "Materials",
  NET: "Technology",
  NEXA: "Mining & Extraction",
  NEXT: "Energy",
  NFE: "Energy",
  NFLX: "Communication Services",
  NHNCF: "Comm. Services",
  NKE: "Consumer Discretionary",
  NMM: "Industrials",
  NNDM: "Technology",
  NNOX: "Healthcare",
  NNYPF: "Materials",
  NOC: "Industrials",
  NOV: "Energy",
  NOVA: "Energy",
  NOVT: "Technology",
  NOW: "Technology",
  NPSNY: "Comm. Services",
  NSC: "Industrials",
  NSRGY: "Consumer Staples",
  NTES: "Comm. Services",
  NTLA: "Healthcare",
  NTNX: "Technology",
  NTRA: "Healthcare",
  NU: "Financials",
  NUE: "Materials",
  NUS: "Consumer Discretionary",
  NUVB: "Healthcare",
  NVDA: "Information Technology",
  NVEE: "Industrials",
  NVEI: "Technology",
  NVO: "Healthcare",
  NVS: "Healthcare",
  NVT: "Industrials",
  NVTA: "Healthcare",
  NXE: "Energy",
  NXPI: "Technology",
  NXRT: "Real Estate",
  NYT: "Communication Services",
  O: "Real Estate",
  ODFL: "Industrials",
  OKE: "Energy",
  OKTA: "Technology",
  OLED: "Technology",
  OLO: "Technology",
  OLPX: "Consumer Discretionary",
  OMC: "Communication Services",
  OMCL: "Healthcare",
  ON: "Technology",
  ONEM: "Healthcare",
  ONON: "Consumer Discretionary",
  ONTO: "Technology",
  OPEN: "Technology",
  OR: "Materials",
  ORCL: "Technology",
  ORLY: "Consumer Disc.",
  OSCR: "Healthcare",
  OSIS: "Industrials",
  OSPN: "Technology",
  OUST: "Technology",
  OXM: "Consumer Discretionary",
  OXY: "Energy",
  PAA: "Energy",
  PACB: "Healthcare",
  PALAF: "Energy",
  PALL: "Precious Metals",
  PANW: "Technology",
  PATH: "Technology",
  PAY: "Technology",
  PAYO: "Technology",
  PBR: "Energy",
  PCG: "Utilities",
  PCVX: "Healthcare",
  PDD: "Consumer Disc.",
  PDFS: "Technology",
  PEG: "Utilities",
  PENN: "Consumer Discretionary",
  PEP: "Consumer Discretionary",
  PERI: "Technology",
  PFE: "Healthcare",
  PFPT: "Technology",
  PG: "Consumer Discretionary",
  PGR: "Financials",
  PHR: "Healthcare",
  PI: "Technology",
  PINS: "Communication Services",
  PIPR: "Financials",
  PKX: "Materials",
  PL: "Technology",
  PLAB: "Technology",
  PLD: "Real Estate",
  PLL: "Materials",
  PLMR: "Financials",
  PLTM: "Precious Metals",
  PLTR: "Technology",
  PLUG: "Industrials",
  PLYA: "Consumer Discretionary",
  PM: "Consumer Staples",
  PNFP: "Financials",
  PNGAY: "Financials",
  PODD: "Healthcare",
  POST: "Consumer Discretionary",
  POWI: "Technology",
  POWL: "Industrials",
  PPG: "Materials",
  PRCH: "Technology",
  PRCT: "Healthcare",
  PRGO: "Healthcare",
  PRGS: "Technology",
  PRKS: "Consumer Discretionary",
  PRMW: "Consumer Staples",
  PRNT: "Industrials",
  PRPL: "Consumer Discretionary",
  PRU: "Financials",
  PSA: "Real Estate",
  PSFE: "Financials",
  PSHG: "Industrials",
  PSNL: "Healthcare",
  PSX: "Energy",
  PTC: "Technology",
  PTRA: "Industrials",
  PUMP: "Energy",
  PVH: "Consumer Discretionary",
  PWR: "Industrials",
  PXD: "Energy",
  PYPL: "Financials",
  QBTS: "Technology",
  QCOM: "Technology",
  QFIN: "Financials",
  QLYS: "Technology",
  QMCO: "Technology",
  QS: "Technology",
  QTS: "Real Estate",
  QUBT: "Technology",
  QUCCF: "Technology",
  R: "Industrials",
  RARE: "Healthcare",
  RBLX: "Technology",
  RCL: "Consumer Discretionary",
  RCUS: "Healthcare",
  RDOR3: "Healthcare",
  RDW: "Industrials",
  RDWR: "Technology",
  RELIANCE: "Energy",
  RELY: "Technology",
  RENT: "Consumer Discretionary",
  RENT3: "Industrials",
  REVG: "Consumer Discretionary",
  REZI: "Industrials",
  RF: "Financials",
  RGLD: "Materials",
  RGTI: "Technology",
  RHHBY: "Healthcare",
  RIOT: "Technology",
  RIVN: "Industrials",
  RKLB: "Industrials",
  RL: "Consumer Discretionary",
  RMBS: "Technology",
  ROK: "Industrials",
  ROST: "Consumer Disc.",
  RPAY: "Financials",
  RPD: "Technology",
  RPRX: "Healthcare",
  RRC: "Energy",
  RRR: "Consumer Discretionary",
  RSI: "Consumer Discretionary",
  RTX: "Industrials",
  RUN: "Energy",
  RVLV: "Consumer Discretionary",
  RVMD: "Healthcare",
  RVNC: "Healthcare",
  RXO: "Industrials",
  RXRX: "Healthcare",
  S: "Technology",
  SAIA: "Industrials",
  SAIC: "Industrials",
  SAIL: "Technology",
  SAM: "Consumer Discretionary",
  SAP: "Technology",
  SATL: "Technology",
  SATS: "Communication Services",
  SB: "Industrials",
  SBAC: "Real Estate",
  SBCF: "Financials",
  SBGSY: "Healthcare",
  SBH: "Consumer Discretionary",
  SBIN: "Financials",
  SBIT: "Technology",
  SBLK: "Industrials",
  SBS: "Utilities",
  SBUX: "Consumer Discretionary",
  SCHW: "Financials",
  SCWX: "Technology",
  SDGR: "Healthcare",
  SEDG: "Technology",
  SEER: "Healthcare",
  SEZL: "Financials",
  SF: "Financials",
  SFL: "Industrials",
  SGHC: "Consumer Discretionary",
  SGMS: "Consumer Discretionary",
  SHEL: "Energy",
  SHG: "Financials",
  SHIP: "Industrials",
  SHOO: "Consumer Discretionary",
  SHOP: "Technology",
  SHW: "Materials",
  SI: "Financials",
  SIEGY: "Industrials",
  SIEN: "Healthcare",
  SITM: "Technology",
  SIVR: "Precious Metals",
  SIX: "Consumer Discretionary",
  SKIN: "Healthcare",
  SKM: "Comm. Services",
  SKX: "Consumer Discretionary",
  SLAB: "Technology",
  SLB: "Energy",
  SLDP: "Technology",
  SLG: "Real Estate",
  SMPL: "Consumer Discretionary",
  SMR: "Manufacturing",
  SNDR: "Industrials",
  SNOW: "Technology",
  SNPS: "Information Technology",
  SNY: "Healthcare",
  SO: "Utilities",
  SOFI: "Financials",
  SPG: "Real Estate",
  SPGI: "Financials",
  SPIR: "Technology",
  SPLK: "Technology",
  SPOT: "Communication Services",
  SPR: "Industrials",
  SPSC: "Technology",
  SPXC: "Industrials",
  SQ: "Financials",
  SQM: "Materials",
  SRCI: "Real Estate",
  SRE: "Utilities",
  SRPT: "Healthcare",
  SRUUF: "Energy",
  SSDIY: "Technology",
  SSL: "Materials",
  SSNC: "Technology",
  SSNLF: "Technology",
  SSYS: "Technology",
  STEM: "Technology",
  STLD: "Materials",
  STNG: "Industrials",
  STRC: "Industrials",
  STZ: "Consumer Discretionary",
  SUPN: "Healthcare",
  SUZ: "Materials",
  SWAV: "Healthcare",
  SWN: "Energy",
  SYK: "Healthcare",
  SYM: "Industrials",
  SYNA: "Technology",
  SYNH: "Healthcare",
  SYRA: "Manufacturing",
  SYY: "Consumer Staples",
  TALK: "Healthcare",
  TAP: "Consumer Discretionary",
  TBILL: "Fixed Income",
  TCEHY: "Comm. Services",
  TCOM: "Consumer Disc.",
  TCS: "Technology",
  TDG: "Industrials",
  TDOC: "Healthcare",
  TECH: "Healthcare",
  TEL: "Industrials",
  TELL: "Energy",
  TENB: "Technology",
  TER: "Technology",
  TFPM: "Materials",
  TFX: "Industrials",
  TGH: "Industrials",
  TGI: "Industrials",
  TILE: "Industrials",
  TJX: "Consumer Disc.",
  TM: "Consumer Disc.",
  TMO: "Healthcare",
  TNDM: "Healthcare",
  TNK: "Industrials",
  TNL: "Consumer Discretionary",
  TOPS: "Industrials",
  TOST: "Technology",
  TPR: "Consumer Discretionary",
  TRGP: "Energy",
  TRIP: "Consumer Discretionary",
  TRMB: "Technology",
  TRMD: "Industrials",
  TRP: "Energy",
  TSAT: "Communication Services",
  TSLA: "Industrials",
  TSM: "Information Technology",
  TT: "Industrials",
  TTE: "Energy",
  TWLO: "Technology",
  TWNK: "Consumer Discretionary",
  TWO: "Financials",
  TWST: "Healthcare",
  TXG: "Healthcare",
  TXN: "Technology",
  TXT: "Industrials",
  TYL: "Technology",
  UAA: "Consumer Discretionary",
  UAL: "Industrials",
  UAVS: "Technology",
  UBER: "Technology",
  UCTT: "Technology",
  UEC: "Energy",
  UFPT: "Healthcare",
  UL: "Consumer Discretionary",
  ULBI: "Industrials",
  ULTA: "Consumer Discretionary",
  UMBF: "Financials",
  UMC: "Technology",
  UNFI: "Consumer Discretionary",
  UNG: "Commodities",
  UNH: "Healthcare",
  UNP: "Industrials",
  UPS: "Industrials",
  UPST: "Financials",
  URA: "Mining & Extraction",
  URBN: "Consumer Discretionary",
  URG: "Energy",
  URI: "Industrials",
  UROY: "Energy",
  USAK: "Industrials",
  USO: "Commodities",
  UTHR: "Healthcare",
  UUUU: "Energy",
  V: "Financials",
  VAC: "Consumer Discretionary",
  VALE: "Materials",
  VCNX: "Healthcare",
  VEEV: "Healthcare",
  VELO: "Technology",
  VERV: "Healthcare",
  VFC: "Consumer Discretionary",
  VHC: "Technology",
  VIAC: "Communication Services",
  VIAV: "Technology",
  VICI: "Real Estate",
  VLO: "Energy",
  VMC: "Materials",
  VMW: "Technology",
  VNET: "Technology",
  VNO: "Real Estate",
  VRNS: "Technology",
  VRNT: "Technology",
  VRSK: "Technology",
  VRSN: "Technology",
  VRT: "Industrials",
  VSAT: "Technology",
  VSEC: "Industrials",
  VST: "Utilities",
  VZ: "Communication Services",
  WAB: "Industrials",
  WAL: "Financials",
  WCC: "Industrials",
  WEC: "Utilities",
  WEG: "Industrials",
  WELL: "Real Estate",
  WERN: "Industrials",
  WFC: "Financials",
  WH: "Consumer Discretionary",
  WIRE: "Industrials",
  WIT: "Technology",
  WKHS: "Industrials",
  WM: "Industrials",
  WMB: "Energy",
  WMG: "Communication Services",
  WMT: "Consumer Staples",
  WOOF: "Consumer Discretionary",
  WPC: "Real Estate",
  WPM: "Materials",
  WRLD: "Financials",
  WSM: "Consumer Disc.",
  WULF: "Technology",
  WYNN: "Consumer Discretionary",
  XEL: "Utilities",
  XENE: "Healthcare",
  XERS: "Healthcare",
  XIACF: "Technology",
  XOM: "Energy",
  XPEL: "Consumer Discretionary",
  XPO: "Industrials",
  YMM: "Industrials",
  ZIM: "Industrials",
  ZION: "Financials",
  ZM: "Technology",
  ZS: "Technology",
  ZTO: "Industrials",
};
